import React from "react";
import Rollbar from '../utils/RollbarTracking'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-responsive-modal';
import axios from 'axios'
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as moment from 'moment-timezone';

import 'react-responsive-modal/styles.css';
import { EditCustomersBulkModal } from "../components/EditCustomersBulkModal";
import { DeleteCustomersBulkModal } from "../components/DeleteCustomersBulkModal";

export class Customers extends React.Component {

  constructor(props)  {
      super(props);
      this.handleChange = this.handleChange.bind(this);
  }

  state = {
      myCustomerData: [],
      email: '',
      modalOpen: false,
      selectedCustomers: [],
      modalOpen2: false,
      modalOpen3: false,
      modalOpen4: false,
      startDate: moment().tz("Australia/Melbourne").subtract(4, 'days').format('YYYY-MM-DD'),
      endDate: moment().tz("Australia/Melbourne").format('YYYY-MM-DD'),
      selectedCustomer: ''
  }

  handleChange (evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  componentWillMount() {
    this.fetchCustomerData();
  }

  inviteCustomer = async () => {
    var cleanedEmailStr = this.state.email.replace(/\s+/g, '');
    var emails = cleanedEmailStr.split(",");
    var i;
    var error = false;
    for (i = 0; i < emails.length; i++) {
      if (!emails[i].match(/[^@]+@[^\.]+\..+/)) {
        error = true;
      }
    }
    if (error) {
      toast.error("Invalid Emails! Please Check Format.");
    }
    else {
      let requestParams = {
        'name': this.props.user.name,
        'email': this.state.email
      }
      axios.post('/email/invite', requestParams)
          .then(data => {
            this.closeModal()
            toast.success("Customer Invitation Email Sent!");
          })
          .catch (err => {
            console.log(err)
            Rollbar.error(err)
            toast.error('Failed to send invite email')
          })
    }
  }

  fetchCustomerData = async () => {
    axios.get('/customers')
        .then(data => {
          console.log(data);
          this.setState({
            myCustomerData: data
          });
        })
        .catch (err => {
          console.log(err);
          Rollbar.error(err)
          toast.error('Failed to fetch customers')
        })
  }

  sendWeeklySummary = async () => {
    toast.warning('Generating Summary...please wait', {autoClose: false})
    let requestParams = {
      'customerID': this.state.selectedCustomer,
      'startDate': this.state.startDate,
      'endDate': this.state.endDate
    }
    axios.post('/customers/weeklysummary', requestParams)
        .then(data => {
          this.closeModal3()
          toast.dismiss()
          console.log(data)
          toast.success("Weekly Invoice Summary Sent!");
        })
        .catch (err => {
          this.closeModal3()
          toast.dismiss()
          console.log(err)
          Rollbar.error(err)
          toast.error('Failed to send weekly summary!')
        })
  }

  cellButton(cell, row, enumObject, rowIndex) {
    return (
      <div>
       <Link to={'/customers/view/' + row.customerID}><button type="button" className="btn btn-info btn-sm mar-right" disabled={!row.status}>View</button></Link>
       <button type="button" className="btn btn-warning btn-sm" disabled={!row.status} onClick={() => this.openModal3(row.customerID)}>Send Summary</button>
      </div>
    )
  }

  openModal = () => {
		this.setState({ modalOpen: true });
	};

	closeModal = () => {
		this.setState({ modalOpen: false });
  };
  
  statusFormatter(cell) {
    if (cell) {
      return '<span class="badge badge-success">Active</span>'
    }
    else {
      return '<span class="badge badge-warning">Pending Invite</span>'
    }
  }

  onRowSelect(row, isSelected, e) {
    let selectedCustomers = this.state.selectedCustomers
    if (isSelected) {
      selectedCustomers.push(row.customerID)
    } else {
      selectedCustomers = selectedCustomers.filter(item => item !== row.customerID)
    }
    this.setState({ selectedCustomers: selectedCustomers })
  }

  onSelectAll(isSelected, rows) {
    if (isSelected) {
      let selectedCustomers = this.state.selectedCustomers
      for (let i = 0; i < rows.length; i++) {
        selectedCustomers.push(rows[i].customerID)
      }
      this.setState({ selectedCustomers: selectedCustomers })
    } else {
      this.setState({ selectedCustomers: [] })
    }
  }

  openModal2 = () => {
		this.setState({ modalOpen2: true });
	};

	closeModal2 = () => {
		this.setState({ modalOpen2: false });
  };

  openModal3 = (id) => {
		this.setState({ modalOpen3: true, selectedCustomer: id });
	};

	closeModal3 = () => {
		this.setState({ modalOpen3: false, selectedCustomer: '' });
  };

  openModal4 = () => {
		this.setState({ modalOpen4: true });
	};

	closeModal4 = () => {
		this.setState({ modalOpen4: false });
  };

    render() {
        return (
          <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
              <h1 className="h3">Customers</h1>
            </div>
            {this.props.settings ? <button type="button" className="btn btn-success btn-sm mar-bot" disabled={this.props.settings.integration.type} onClick={this.openModal}>Add Customer</button>: null}
            {this.props.settings.integration.type == 'myob' ? <Link to={"/customers/import"} className="btn btn-info btn-sm mar-bot ml-1">Import Customers</Link>: this.props.settings.integration.type == 'xero' ? <Link to={"/customers/import/xero"} className="btn btn-info btn-sm mar-bot ml-1">Import Customers</Link> : null}
            <button type="button" className="btn btn-warning btn-sm mar-bot ml-1" disabled={!this.state.selectedCustomers.length} onClick={this.openModal2}>Edit ({this.state.selectedCustomers.length}) Customers</button>
            <button type="button" className="btn btn-danger btn-sm mar-bot ml-1" disabled={!this.state.selectedCustomers.length} onClick={this.openModal4}>Remove ({this.state.selectedCustomers.length}) Customers</button>
            <BootstrapTable data={this.state.myCustomerData} striped={true} hover={true} options={{sizePerPage: 50}} selectRow={{ mode: 'checkbox', onSelect: this.onRowSelect.bind(this), onSelectAll: this.onSelectAll.bind(this), columnWidth: '2.75em' }} pagination>
              <TableHeaderColumn dataField="customerID" isKey={true}>Customer ID</TableHeaderColumn>
              <TableHeaderColumn dataField="name" dataSort={true}>Name</TableHeaderColumn>
              <TableHeaderColumn dataField="company" dataSort={true}>Company</TableHeaderColumn>
              <TableHeaderColumn dataField="status" dataFormat={this.statusFormatter} dataSort={true}>Status</TableHeaderColumn>
              <TableHeaderColumn dataFormat={this.cellButton.bind(this)}>Action</TableHeaderColumn>
            </BootstrapTable>
            <Modal open={this.state.modalOpen} onClose={this.closeModal} center showCloseIcon={false} classNames={{ modal: 'modal' }}>
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add Customer</h5>
                    <button type="button" className="close" onClick={this.closeModal}>
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <p>Please enter your customer's email address below to send the signup instructions and supplier code to your customer. You can enter multiple email address, seperated by a comma (,)</p>
                    <div className="form-group">
                      <label>Customer Email:</label>
                      <textarea className="form-control" name="email" rows="3" placeholder="john@gmail.com,
jessica@example.com,
rahul@hotmail.com" value={this.state.email} onChange={this.handleChange} />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={this.closeModal}>Close</button>
                    <button type="button" onClick={this.inviteCustomer} className="btn btn-primary">Send Invite</button>
                  </div>
                </div>
              </div>
            </Modal>
            <Modal open={this.state.modalOpen2} onClose={this.closeModal2} center showCloseIcon={false} classNames={{ modal: 'modal' }}>
              <EditCustomersBulkModal closeModal={this.closeModal2} customers={this.state.selectedCustomers} />
            </Modal>
            <Modal open={this.state.modalOpen3} onClose={this.closeModal3} center showCloseIcon={false} classNames={{ modal: 'modal' }}>
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Send Weekly Summary</h5>
                    <button type="button" className="close" onClick={this.closeModal3}>
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="form-group">
                      <label>Start Date:</label>
                      <input type="date" className="form-control" name="startDate" value={this.state.startDate} onChange={this.handleChange} />
                    </div>
                    <div className="form-group">
                      <label>End Date:</label>
                      <input type="date" className="form-control" name="endDate" value={this.state.endDate} onChange={this.handleChange} />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={this.closeModal3}>Close</button>
                    <button type="button" onClick={this.sendWeeklySummary} disabled={!this.state.startDate || !this.state.endDate} className="btn btn-primary">Send</button>
                  </div>
                </div>
              </div>
            </Modal>
            <Modal open={this.state.modalOpen4} onClose={this.closeModal4} center showCloseIcon={false} classNames={{ modal: 'modal' }}>
              <DeleteCustomersBulkModal closeModal={this.closeModal4} fetchCustomerData={this.fetchCustomerData} customers={this.state.selectedCustomers} />
            </Modal>
          </div>
        );
    }
}
